module.exports = "/assets/eighthexsvg-c49e55046b0fd91807a2ecbbb6dcf80d.svg";